import React from 'react';
import PropTypes from 'prop-types';

import displayStyles from './style/display.css';

export default function MaxWidth({ children, display, value }) {
  return (
    <div className={displayStyles[display]} style={{ maxWidth: value }}>
      {children}
    </div>
  );
}

MaxWidth.propTypes = {
  children: PropTypes.node.isRequired,
  display: PropTypes.oneOf(Object.keys(displayStyles)),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MaxWidth.defaultProps = {
  display: 'inlineBlock',
  value: 'auto',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-max-width/MaxWidth/index.js